import { DropDownList } from "@progress/kendo-react-dropdowns";
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import SaleTypeModel from "../../models/masters/saletype-model";
import * as Yup from "yup";

interface SaleTypeEditProps {
    data: SaleTypeModel;
    onClose?: (status: SubmitStatus, data: any) => any;
  }


const SaleTypeEntry: React.FC<SaleTypeEditProps> = ({ ...props }) => {
    let { data, onClose } = props;
    const title = data?.saleTypeId > 0 ? "Edit SaleType" : "Add SaleType";
  
    let initialValue: SaleTypeModel = {
        saleTypeId: data?.saleTypeId ? data.saleTypeId : 0,
        name: data?.name 
    };
    const validationSchema = Yup.object().shape({
      name: Yup.string().required("Required"),
    
    });
    console.log(initialValue)
  
  
    return (
      <>
        <FormikModelDialog
          width="50%"
          title={title}
          initialData={initialValue}
          validationSchema={validationSchema}
          show={!!data}
          onClose={onClose}
          endpoint={API_END_POINT.MASTER}
          postRoute="SaleType/SaveSaleType"
          showAddAnother={true}
          isUpDateEntityDetails={data?.saleTypeId>0? true: false}
        >
           <div>
          <div className="row">
            <div className="col-12">
              <InputField maxLength={3}
               label=" Name *" 
               name="name" />
            </div>
         
          </div>
        </div>
        </FormikModelDialog>
      </>
    );
  };


  export default SaleTypeEntry;